import { render, staticRenderFns } from "./DevBpbjWarehousingListList.vue?vue&type=template&id=10b837a1&scoped=true&"
import script from "./DevBpbjWarehousingListList.vue?vue&type=script&lang=js&"
export * from "./DevBpbjWarehousingListList.vue?vue&type=script&lang=js&"
import style0 from "./DevBpbjWarehousingListList.vue?vue&type=style&index=0&id=10b837a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b837a1",
  null
  
)

export default component.exports